/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Friend_Guest_Cancel_SuccessInputs */

const fr_membership_friend_guest_cancel_success = /** @type {(inputs: Membership_Friend_Guest_Cancel_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation annulée.`)
};

/**

* @param {Membership_Friend_Guest_Cancel_SuccessInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_friend_guest_cancel_success = /** @type {((inputs?: Membership_Friend_Guest_Cancel_SuccessInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Friend_Guest_Cancel_SuccessInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_friend_guest_cancel_success(inputs)
});